import { useForm } from "react-hook-form";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import { useEffect } from "react";
import {ITagDto} from "../../../Apis/Models/ITagDto";
import {useMutateTag} from "../../../Apis/TagApi";

interface IProps {
    tag?: ITagDto;
    onSubmit?: (data: ITagDto) => void;
}
const TagForm = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { control, handleSubmit, reset } = useForm<ITagDto>()
    const { mutateAsync, isLoading } = useMutateTag();
    
    useEffect(() => {
        if (props.tag) {
            reset(props.tag);
        }
    }, [reset, props.tag])
    
    const onSubmit = async(data: ITagDto) => {
        await mutateAsync(data);
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default TagForm
